<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
                @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                </template>
                <template slot-scope="scope" slot="menu">
                    <!-- 二维码失效 -->
                    <el-button type="danger" icon="el-icon-delete" size="mini" plain
                        @click.stop="handleDel(scope.row)">失效</el-button>
                </template>
                <template slot-scope="scope" slot="brandNameForm">
                    <el-select v-model="brand" placeholder="请选择品牌" required value-key="id">
                        <el-option v-for="brand in brands" :key="brand.id" :label="brand.name"
                            :value="brand"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="firstClassifyNameForm">
                    <el-select v-model="classify" placeholder="请选择商品一级分类" required @change="chooseSecondClassify"
                        value-key="id">
                        <el-option v-for="classify in classifies" :key="classify.id" :label="classify.name"
                            :value="classify"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="secondClassifyNameForm">
                    <el-select v-model="secondClassify" placeholder="请选择商品二级分类" required
                        @change="findGoodsByRootDepartId" value-key="id">
                        <el-option v-for="secondClassify in secondClassifies" :key="secondClassify.id"
                            :label="secondClassify.name" :value="secondClassify"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="stuffNameForm">
                    <el-select v-model="department" placeholder="请选择代理商" required @change="findGoodsByRootDepartId"
                        value-key="id">
                        <el-option v-for="department in departments" :key="department.id" :label="department.name"
                            :value="department"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="goodsNameForm">
                    <el-select v-model="goods" placeholder="请选择商品" required value-key="id">
                        <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name"
                            :value="goods"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="status">
                    <div v-for="obj of QRStatus" :key="obj.value" v-if="obj.value == scope.row.status">
                        <el-tag v-if="scope.row.status == 'GOING'" type="success"> {{ obj.label }}</el-tag>
                        <el-tag v-else-if="scope.row.status == 'DNS'" type="info"> {{ obj.label }}</el-tag>
                        <el-tag v-else type="danger"> {{ obj.label }}</el-tag>
                    </div>
                </template>
            </avue-crud>

        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { goodsQrDetailsOption } from "@/const/salesCloud/goodsQrDetailsOption";
import { batchDownloadQr, findGoodsQr, addGoodsQr, deleteQr, findGoodsByRootDepartId, chooseSecondClassify } from "@/api/sales/goodsQr"
import { findByLabel, formatterTime } from "@/util/util"
import { DIC } from "@/const/dic"

export default {
    name: "goodsQrDetails",
    data() {
        return {
            tableOption: goodsQrDetailsOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            tabelObj: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            grade: {
                box: false,
                check: []
            },
            detailVisible: false,
            detailData: [],
            selectRedPacket: {

            },
            detailSearch: {
            },
            detailPage: {
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            brands: [],
            brand: {},
            classifies: [],
            classify: {},
            departments: [],
            department: {},
            secondClassifies: [],
            secondClassify: {},
            goodsList: [],
            goods: {},
            QRStatus: DIC.QR_STATUS,
            id: this.$route.query.id

        };
    },
    created() {
        this.handleList();
    },
    watch: {},
    mounted() {
        const columns = this.$refs.crud.tableOption.column;
        // 删除操作columns的2、4、5、6中的hide
        delete columns[2].hide;
        delete columns[4].hide;
        delete columns[5].hide;
        delete columns[6].hide;
    },
    computed: {
        ...mapGetters(["permission"])
    },
    props: [],
    methods: {
        pageSizeChange(pageSize) {

            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage,
                params.size = pageSize
            findGoodsQr(this.id, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            })
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page
            params.size = this.page.pageSize
            findGoodsQr(this.id, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        searchChange(params) {
            this.tableLoading = true;
            // let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage
            params.size = this.page.pageSize
            findGoodsQr(this.id, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size
                };
                this.tableLoading = false;
            })
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page.currentPage
            params.size = page.pageSize
            findGoodsQr(this.id, params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            if (null != row.startDate && undefined != row.startDate && null != row.endDate && undefined != row.endDate) {
                let time = new Array()
                time.push(row.startDate)
                time.push(row.endDate)
                row.startDate_endDate = time
            }
            this.$refs.crud.rowEdit(row, index);
        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let parmas = {
                page: this.page.currentPage,
                size: this.page.pageSize
            }
            findGoodsQr(this.id, parmas).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave(row, done) {
            let data = {}
            if (null != row.startDate_endDate && undefined != row.startDate_endDate) {
                data.startTime = row.startDate_endDate[0]
                data.endTime = row.startDate_endDate[1]
            }
            data.goodsBrandId = this.brand.id
            data.goodsId = this.goods.id
            data.firstClassify = this.classify.id
            data.secondClassify = this.secondClassify.id
            data.stuffId = this.department.id
            data.promotionCost = row.promotionCost
            data.num = row.num
            data.name = row.name
            addGoodsQr(data).then(response => {
                if (response.code == '200') {
                    this.$message({
                        showClose: true,
                        message: "添加成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error"
                    })
                }

            }).catch(error => {
                this.loading = false
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                })
            })
            done();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
            // console.log(val);
            // this.tableRow = val;
            // this.$notify({
            //     showClose: true,
            //     message: JSON.stringify(val),
            //     type: 'success',
            // });
        },

        /**
    * @title 数据失效
    * @param row 为当前的数据
    * @param index 为当前更新数据的行数
    *
    **/
        handleDel(row) {
            console.log(row);
            if (row.status == 'EXPIRE') {
                this.$message({
                    showClose: true,
                    message: "该二维码已失效",
                    type: "error",
                });
                return;
            }
            // 确认失效商品二维码（name）吗
            this.$confirm("确认失效商品二维码（" + row.name + "）吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteQr(row.id).then((res) => {
                        if (res.code == '200') {
                            this.$message({
                                showClose: true,
                                message: "失效成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "已取消失效",
                        type: "info",
                    });
                });
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) {

        },
        chooseSecondClassify() {
            chooseSecondClassify(this.classify.id).then((res) => {
                let data = JSON.parse(res.data);
                this.secondClassifies = data
                this.findGoodsByRootDepartId();
            });
        },
        findGoodsByRootDepartId() {
            let data = {}

            if (typeof this.classify.id != 'undefined') {
                data.firstClassify = this.classify.id
            }
            if (typeof this.secondClassify.id != 'undefined') {
                data.secondClassify = this.secondClassify.id
            }
            if (typeof this.brand.id != 'undefined') {
                data.brandId = this.brand.id
            }


            findGoodsByRootDepartId(this.department.id, data).then((res) => {
                let data = JSON.parse(res.data);
                this.goodsList = data
            });
        },
        tableToExcel() {
            let ids = new Array();
            for (let row of this.$refs.crud.tableSelect) {
                ids.push(row.id)
            }
            batchDownloadQr(ids).then((res) => {
                let data = JSON.parse(res.data);
                console.log("商品：" + JSON.stringify(data))
                let jsonData = []
                for (let i = 0; i < data.length; i++) {
                    jsonData.push({ "name": "preFilter:" + data[i] })

                }
                //列标题，逗号隔开，每一个逗号就是隔开一个单元格
                let str = `链接\n`;
                //增加\t为了不让表格显示科学计数法或者其他格式
                for (let i = 0; i < jsonData.length; i++) {
                    for (let item in jsonData[i]) {
                        str += `${jsonData[i][item]},`;
                    }
                    str += '\n';
                }
                //encodeURIComponent解决中文乱码
                let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
                //通过创建a标签实现
                var link = document.createElement("a");
                link.href = uri;
                //对下载的文件命名
                link.download = "二维码链接.csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
            // let jsonData =[]
            // for(let row of this.$refs.crud.tableSelect){
            //     jsonData.push({"name":"preFilter:"+row.id})
            // }

        },
        func() {
            this.$router.push({ name: "收费标准管理", path: "/work/takePercentage" });
        }

    }

};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
